import b from "react";
var he = (e) => e.type === "checkbox", le = (e) => e instanceof Date, j = (e) => e == null;
const _t = (e) => typeof e == "object";
var I = (e) => !j(e) && !Array.isArray(e) && _t(e) && !le(e), ht = (e) => I(e) && e.target ? he(e.target) ? e.target.checked : e.target.value : e, It = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, mt = (e, r) => e.has(It(r)), Nt = (e) => {
  const r = e.constructor && e.constructor.prototype;
  return I(r) && r.hasOwnProperty("isPrototypeOf");
}, je = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function O(e) {
  let r;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    r = new Date(e);
  else if (!(je && (e instanceof Blob || i)) && (t || I(e)))
    if (r = t ? [] : Object.create(Object.getPrototypeOf(e)), !t && !Nt(e))
      r = e;
    else
      for (const u in e)
        e.hasOwnProperty(u) && (r[u] = O(e[u]));
  else
    return e;
  return r;
}
var Se = (e) => /^\w*$/.test(e), R = (e) => e === void 0, we = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Ke = (e) => we(e.replace(/["|']|\]/g, "").split(/\.|\[/)), d = (e, r, t) => {
  if (!r || !I(e))
    return t;
  const i = (Se(r) ? [r] : Ke(r)).reduce((u, n) => j(u) ? u : u[n], e);
  return R(i) || i === e ? R(e[r]) ? t : e[r] : i;
}, Y = (e) => typeof e == "boolean", E = (e, r, t) => {
  let i = -1;
  const u = Se(r) ? [r] : Ke(r), n = u.length, f = n - 1;
  for (; ++i < n; ) {
    const c = u[i];
    let S = t;
    if (i !== f) {
      const x = e[c];
      S = I(x) || Array.isArray(x) ? x : isNaN(+u[i + 1]) ? {} : [];
    }
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return;
    e[c] = S, e = e[c];
  }
};
const Ve = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Q = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, se = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, ze = b.createContext(null);
ze.displayName = "HookFormContext";
const ke = () => b.useContext(ze), ir = (e) => {
  const { children: r, ...t } = e;
  return b.createElement(ze.Provider, { value: t }, r);
};
var vt = (e, r, t, i = !0) => {
  const u = {
    defaultValues: r._defaultValues
  };
  for (const n in e)
    Object.defineProperty(u, n, {
      get: () => {
        const f = n;
        return r._proxyFormState[f] !== Q.all && (r._proxyFormState[f] = !i || Q.all), t && (t[f] = !0), e[f];
      }
    });
  return u;
};
const De = typeof window < "u" ? b.useLayoutEffect : b.useEffect;
function Bt(e) {
  const r = ke(), { control: t = r.control, disabled: i, name: u, exact: n } = e || {}, [f, c] = b.useState(t._formState), S = b.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return De(() => t._subscribe({
    name: u,
    formState: S.current,
    exact: n,
    callback: (x) => {
      !i && c({
        ...t._formState,
        ...x
      });
    }
  }), [u, i, n]), b.useEffect(() => {
    S.current.isValid && t._setValid(!0);
  }, [t]), b.useMemo(() => vt(f, t, S.current, !1), [f, t]);
}
var re = (e) => typeof e == "string", bt = (e, r, t, i, u) => re(e) ? (i && r.watch.add(e), d(t, e, u)) : Array.isArray(e) ? e.map((n) => (i && r.watch.add(n), d(t, n))) : (i && (r.watchAll = !0), t), qe = (e) => j(e) || !_t(e);
function ie(e, r, t = /* @__PURE__ */ new WeakSet()) {
  if (qe(e) || qe(r))
    return e === r;
  if (le(e) && le(r))
    return e.getTime() === r.getTime();
  const i = Object.keys(e), u = Object.keys(r);
  if (i.length !== u.length)
    return !1;
  if (t.has(e) || t.has(r))
    return !0;
  t.add(e), t.add(r);
  for (const n of i) {
    const f = e[n];
    if (!u.includes(n))
      return !1;
    if (n !== "ref") {
      const c = r[n];
      if (le(f) && le(c) || I(f) && I(c) || Array.isArray(f) && Array.isArray(c) ? !ie(f, c, t) : f !== c)
        return !1;
    }
  }
  return !0;
}
function Pt(e) {
  const r = ke(), { control: t = r.control, name: i, defaultValue: u, disabled: n, exact: f, compute: c } = e || {}, S = b.useRef(u), x = b.useRef(c), A = b.useRef(void 0);
  x.current = c;
  const w = b.useMemo(() => t._getWatch(i, S.current), [t, i]), [h, G] = b.useState(x.current ? x.current(w) : w);
  return De(() => t._subscribe({
    name: i,
    formState: {
      values: !0
    },
    exact: f,
    callback: (q) => {
      if (!n) {
        const C = bt(i, t._names, q.values || t._formValues, !1, S.current);
        if (x.current) {
          const B = x.current(C);
          ie(B, A.current) || (G(B), A.current = B);
        } else
          G(C);
      }
    }
  }), [t, n, i, f]), b.useEffect(() => t._removeUnmounted()), h;
}
function Wt(e) {
  const r = ke(), { name: t, disabled: i, control: u = r.control, shouldUnregister: n, defaultValue: f } = e, c = mt(u._names.array, t), S = b.useMemo(() => d(u._formValues, t, d(u._defaultValues, t, f)), [u, t, f]), x = Pt({
    control: u,
    name: t,
    defaultValue: S,
    exact: !0
  }), A = Bt({
    control: u,
    name: t,
    exact: !0
  }), w = b.useRef(e), h = b.useRef(u.register(t, {
    ...e.rules,
    value: x,
    ...Y(e.disabled) ? { disabled: e.disabled } : {}
  }));
  w.current = e;
  const G = b.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!d(A.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!d(A.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!d(A.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!d(A.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => d(A.errors, t)
    }
  }), [A, t]), q = b.useCallback((V) => h.current.onChange({
    target: {
      value: ht(V),
      name: t
    },
    type: Ve.CHANGE
  }), [t]), C = b.useCallback(() => h.current.onBlur({
    target: {
      value: d(u._formValues, t),
      name: t
    },
    type: Ve.BLUR
  }), [t, u._formValues]), B = b.useCallback((V) => {
    const P = d(u._fields, t);
    P && V && (P._f.ref = {
      focus: () => V.focus && V.focus(),
      select: () => V.select && V.select(),
      setCustomValidity: (N) => V.setCustomValidity(N),
      reportValidity: () => V.reportValidity()
    });
  }, [u._fields, t]), ae = b.useMemo(() => ({
    name: t,
    value: x,
    ...Y(i) || A.disabled ? { disabled: A.disabled || i } : {},
    onChange: q,
    onBlur: C,
    ref: B
  }), [t, i, A.disabled, q, C, B, x]);
  return b.useEffect(() => {
    const V = u._options.shouldUnregister || n;
    u.register(t, {
      ...w.current.rules,
      ...Y(w.current.disabled) ? { disabled: w.current.disabled } : {}
    });
    const P = (N, _) => {
      const m = d(u._fields, N);
      m && m._f && (m._f.mount = _);
    };
    if (P(t, !0), V) {
      const N = O(d(u._options.defaultValues, t));
      E(u._defaultValues, t, N), R(d(u._formValues, t)) && E(u._formValues, t, N);
    }
    return !c && u.register(t), () => {
      (c ? V && !u._state.action : V) ? u.unregister(t) : P(t, !1);
    };
  }, [t, u, c, n]), b.useEffect(() => {
    u._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, u]), b.useMemo(() => ({
    field: ae,
    formState: A,
    fieldState: G
  }), [ae, A, G]);
}
const ar = (e) => e.render(Wt(e));
var qt = (e, r, t, i, u) => r ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: u || !0
  }
} : {}, z = (e) => Array.isArray(e) ? e : [e], ut = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (u) => {
      for (const n of e)
        n.next && n.next(u);
    },
    subscribe: (u) => (e.push(u), {
      unsubscribe: () => {
        e = e.filter((n) => n !== u);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, $ = (e) => I(e) && !Object.keys(e).length, Ge = (e) => e.type === "file", X = (e) => typeof e == "function", Fe = (e) => {
  if (!je)
    return !1;
  const r = e ? e.ownerDocument : 0;
  return e instanceof (r && r.defaultView ? r.defaultView.HTMLElement : HTMLElement);
}, Vt = (e) => e.type === "select-multiple", Ye = (e) => e.type === "radio", Ht = (e) => Ye(e) || he(e), Re = (e) => Fe(e) && e.isConnected;
function $t(e, r) {
  const t = r.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = R(e) ? i++ : e[r[i++]];
  return e;
}
function jt(e) {
  for (const r in e)
    if (e.hasOwnProperty(r) && !R(e[r]))
      return !1;
  return !0;
}
function T(e, r) {
  const t = Array.isArray(r) ? r : Se(r) ? [r] : Ke(r), i = t.length === 1 ? e : $t(e, t), u = t.length - 1, n = t[u];
  return i && delete i[n], u !== 0 && (I(i) && $(i) || Array.isArray(i) && jt(i)) && T(e, t.slice(0, -1)), e;
}
var Ft = (e) => {
  for (const r in e)
    if (X(e[r]))
      return !0;
  return !1;
};
function Ae(e, r = {}) {
  const t = Array.isArray(e);
  if (I(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || I(e[i]) && !Ft(e[i]) ? (r[i] = Array.isArray(e[i]) ? [] : {}, Ae(e[i], r[i])) : j(e[i]) || (r[i] = !0);
  return r;
}
function At(e, r, t) {
  const i = Array.isArray(e);
  if (I(e) || i)
    for (const u in e)
      Array.isArray(e[u]) || I(e[u]) && !Ft(e[u]) ? R(r) || qe(t[u]) ? t[u] = Array.isArray(e[u]) ? Ae(e[u], []) : { ...Ae(e[u]) } : At(e[u], j(r) ? {} : r[u], t[u]) : t[u] = !ie(e[u], r[u]);
  return t;
}
var ge = (e, r) => At(e, r, Ae(r));
const nt = {
  value: !1,
  isValid: !1
}, lt = { value: !0, isValid: !0 };
var xt = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const r = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: r, isValid: !!r.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !R(e[0].attributes.value) ? R(e[0].value) || e[0].value === "" ? lt : { value: e[0].value, isValid: !0 } : lt
    ) : nt;
  }
  return nt;
}, St = (e, { valueAsNumber: r, valueAsDate: t, setValueAs: i }) => R(e) ? e : r ? e === "" ? NaN : e && +e : t && re(e) ? new Date(e) : i ? i(e) : e;
const ot = {
  isValid: !1,
  value: null
};
var wt = (e) => Array.isArray(e) ? e.reduce((r, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : r, ot) : ot;
function ct(e) {
  const r = e.ref;
  return Ge(r) ? r.files : Ye(r) ? wt(e.refs).value : Vt(r) ? [...r.selectedOptions].map(({ value: t }) => t) : he(r) ? xt(e.refs).value : St(R(r.value) ? e.ref.value : r.value, e);
}
var Kt = (e, r, t, i) => {
  const u = {};
  for (const n of e) {
    const f = d(r, n);
    f && E(u, n, f._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: u,
    shouldUseNativeValidation: i
  };
}, xe = (e) => e instanceof RegExp, _e = (e) => R(e) ? e : xe(e) ? e.source : I(e) ? xe(e.value) ? e.value.source : e.value : e, de = (e) => ({
  isOnSubmit: !e || e === Q.onSubmit,
  isOnBlur: e === Q.onBlur,
  isOnChange: e === Q.onChange,
  isOnAll: e === Q.all,
  isOnTouch: e === Q.onTouched
});
const dt = "AsyncFunction";
var zt = (e) => !!e && !!e.validate && !!(X(e.validate) && e.validate.constructor.name === dt || I(e.validate) && Object.values(e.validate).find((r) => r.constructor.name === dt)), Gt = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), He = (e, r, t) => !t && (r.watchAll || r.watch.has(e) || [...r.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const fe = (e, r, t, i) => {
  for (const u of t || Object.keys(e)) {
    const n = d(e, u);
    if (n) {
      const { _f: f, ...c } = n;
      if (f) {
        if (f.refs && f.refs[0] && r(f.refs[0], u) && !i)
          return !0;
        if (f.ref && r(f.ref, f.name) && !i)
          return !0;
        if (fe(c, r))
          break;
      } else if (I(c) && fe(c, r))
        break;
    }
  }
};
function ft(e, r, t) {
  const i = d(e, t);
  if (i || Se(t))
    return {
      error: i,
      name: t
    };
  const u = t.split(".");
  for (; u.length; ) {
    const n = u.join("."), f = d(r, n), c = d(e, n);
    if (f && !Array.isArray(f) && t !== n)
      return { name: t };
    if (c && c.type)
      return {
        name: n,
        error: c
      };
    if (c && c.root && c.root.type)
      return {
        name: `${n}.root`,
        error: c.root
      };
    u.pop();
  }
  return {
    name: t
  };
}
var Yt = (e, r, t, i) => {
  t(e);
  const { name: u, ...n } = e;
  return $(n) || Object.keys(n).length >= Object.keys(r).length || Object.keys(n).find((f) => r[f] === (!i || Q.all));
}, Jt = (e, r, t) => !e || !r || e === r || z(e).some((i) => i && (t ? i === r : i.startsWith(r) || r.startsWith(i))), Qt = (e, r, t, i, u) => u.isOnAll ? !1 : !t && u.isOnTouch ? !(r || e) : (t ? i.isOnBlur : u.isOnBlur) ? !e : (t ? i.isOnChange : u.isOnChange) ? e : !0, Xt = (e, r) => !we(d(e, r)).length && T(e, r), kt = (e, r, t) => {
  const i = z(d(e, t));
  return E(i, "root", r[t]), E(e, t, i), e;
}, be = (e) => re(e);
function yt(e, r, t = "validate") {
  if (be(e) || Array.isArray(e) && e.every(be) || Y(e) && !e)
    return {
      type: t,
      message: be(e) ? e : "",
      ref: r
    };
}
var ce = (e) => I(e) && !xe(e) ? e : {
  value: e,
  message: ""
}, $e = async (e, r, t, i, u, n) => {
  const { ref: f, refs: c, required: S, maxLength: x, minLength: A, min: w, max: h, pattern: G, validate: q, name: C, valueAsNumber: B, mount: ae } = e._f, V = d(t, C);
  if (!ae || r.has(C))
    return {};
  const P = c ? c[0] : f, N = (k) => {
    u && P.reportValidity && (P.setCustomValidity(Y(k) ? "" : k || ""), P.reportValidity());
  }, _ = {}, m = Ye(f), F = he(f), U = m || F, W = (B || Ge(f)) && R(f.value) && R(V) || Fe(f) && f.value === "" || V === "" || Array.isArray(V) && !V.length, Z = qt.bind(null, C, i, _), ee = (k, p, L, H = se.maxLength, K = se.minLength) => {
    const te = k ? p : L;
    _[C] = {
      type: k ? H : K,
      message: te,
      ref: f,
      ...Z(k ? H : K, te)
    };
  };
  if (n ? !Array.isArray(V) || !V.length : S && (!U && (W || j(V)) || Y(V) && !V || F && !xt(c).isValid || m && !wt(c).isValid)) {
    const { value: k, message: p } = be(S) ? { value: !!S, message: S } : ce(S);
    if (k && (_[C] = {
      type: se.required,
      message: p,
      ref: P,
      ...Z(se.required, p)
    }, !i))
      return N(p), _;
  }
  if (!W && (!j(w) || !j(h))) {
    let k, p;
    const L = ce(h), H = ce(w);
    if (!j(V) && !isNaN(V)) {
      const K = f.valueAsNumber || V && +V;
      j(L.value) || (k = K > L.value), j(H.value) || (p = K < H.value);
    } else {
      const K = f.valueAsDate || new Date(V), te = (me) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + me), ye = f.type == "time", oe = f.type == "week";
      re(L.value) && V && (k = ye ? te(V) > te(L.value) : oe ? V > L.value : K > new Date(L.value)), re(H.value) && V && (p = ye ? te(V) < te(H.value) : oe ? V < H.value : K < new Date(H.value));
    }
    if ((k || p) && (ee(!!k, L.message, H.message, se.max, se.min), !i))
      return N(_[C].message), _;
  }
  if ((x || A) && !W && (re(V) || n && Array.isArray(V))) {
    const k = ce(x), p = ce(A), L = !j(k.value) && V.length > +k.value, H = !j(p.value) && V.length < +p.value;
    if ((L || H) && (ee(L, k.message, p.message), !i))
      return N(_[C].message), _;
  }
  if (G && !W && re(V)) {
    const { value: k, message: p } = ce(G);
    if (xe(k) && !V.match(k) && (_[C] = {
      type: se.pattern,
      message: p,
      ref: f,
      ...Z(se.pattern, p)
    }, !i))
      return N(p), _;
  }
  if (q) {
    if (X(q)) {
      const k = await q(V, t), p = yt(k, P);
      if (p && (_[C] = {
        ...p,
        ...Z(se.validate, p.message)
      }, !i))
        return N(p.message), _;
    } else if (I(q)) {
      let k = {};
      for (const p in q) {
        if (!$(k) && !i)
          break;
        const L = yt(await q[p](V, t), P, p);
        L && (k = {
          ...L,
          ...Z(p, L.message)
        }, N(L.message), i && (_[C] = k));
      }
      if (!$(k) && (_[C] = {
        ref: P,
        ...k
      }, !i))
        return _;
    }
  }
  return N(!0), _;
};
const Zt = {
  mode: Q.onSubmit,
  reValidateMode: Q.onChange,
  shouldFocusError: !0
};
function er(e = {}) {
  let r = {
    ...Zt,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: X(r.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: r.errors || {},
    disabled: r.disabled || !1
  }, i = {}, u = I(r.defaultValues) || I(r.values) ? O(r.defaultValues || r.values) || {} : {}, n = r.shouldUnregister ? {} : O(u), f = {
    action: !1,
    mount: !1,
    watch: !1
  }, c = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, S, x = 0;
  const A = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let w = {
    ...A
  };
  const h = {
    array: ut(),
    state: ut()
  }, G = r.criteriaMode === Q.all, q = (s) => (a) => {
    clearTimeout(x), x = setTimeout(s, a);
  }, C = async (s) => {
    if (!r.disabled && (A.isValid || w.isValid || s)) {
      const a = r.resolver ? $((await F()).errors) : await W(i, !0);
      a !== t.isValid && h.state.next({
        isValid: a
      });
    }
  }, B = (s, a) => {
    !r.disabled && (A.isValidating || A.validatingFields || w.isValidating || w.validatingFields) && ((s || Array.from(c.mount)).forEach((l) => {
      l && (a ? E(t.validatingFields, l, a) : T(t.validatingFields, l));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !$(t.validatingFields)
    }));
  }, ae = (s, a = [], l, g, y = !0, o = !0) => {
    if (g && l && !r.disabled) {
      if (f.action = !0, o && Array.isArray(d(i, s))) {
        const v = l(d(i, s), g.argA, g.argB);
        y && E(i, s, v);
      }
      if (o && Array.isArray(d(t.errors, s))) {
        const v = l(d(t.errors, s), g.argA, g.argB);
        y && E(t.errors, s, v), Xt(t.errors, s);
      }
      if ((A.touchedFields || w.touchedFields) && o && Array.isArray(d(t.touchedFields, s))) {
        const v = l(d(t.touchedFields, s), g.argA, g.argB);
        y && E(t.touchedFields, s, v);
      }
      (A.dirtyFields || w.dirtyFields) && (t.dirtyFields = ge(u, n)), h.state.next({
        name: s,
        isDirty: ee(s, a),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      E(n, s, a);
  }, V = (s, a) => {
    E(t.errors, s, a), h.state.next({
      errors: t.errors
    });
  }, P = (s) => {
    t.errors = s, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, N = (s, a, l, g) => {
    const y = d(i, s);
    if (y) {
      const o = d(n, s, R(l) ? d(u, s) : l);
      R(o) || g && g.defaultChecked || a ? E(n, s, a ? o : ct(y._f)) : L(s, o), f.mount && C();
    }
  }, _ = (s, a, l, g, y) => {
    let o = !1, v = !1;
    const D = {
      name: s
    };
    if (!r.disabled) {
      if (!l || g) {
        (A.isDirty || w.isDirty) && (v = t.isDirty, t.isDirty = D.isDirty = ee(), o = v !== D.isDirty);
        const M = ie(d(u, s), a);
        v = !!d(t.dirtyFields, s), M ? T(t.dirtyFields, s) : E(t.dirtyFields, s, !0), D.dirtyFields = t.dirtyFields, o = o || (A.dirtyFields || w.dirtyFields) && v !== !M;
      }
      if (l) {
        const M = d(t.touchedFields, s);
        M || (E(t.touchedFields, s, l), D.touchedFields = t.touchedFields, o = o || (A.touchedFields || w.touchedFields) && M !== l);
      }
      o && y && h.state.next(D);
    }
    return o ? D : {};
  }, m = (s, a, l, g) => {
    const y = d(t.errors, s), o = (A.isValid || w.isValid) && Y(a) && t.isValid !== a;
    if (r.delayError && l ? (S = q(() => V(s, l)), S(r.delayError)) : (clearTimeout(x), S = null, l ? E(t.errors, s, l) : T(t.errors, s)), (l ? !ie(y, l) : y) || !$(g) || o) {
      const v = {
        ...g,
        ...o && Y(a) ? { isValid: a } : {},
        errors: t.errors,
        name: s
      };
      t = {
        ...t,
        ...v
      }, h.state.next(v);
    }
  }, F = async (s) => {
    B(s, !0);
    const a = await r.resolver(n, r.context, Kt(s || c.mount, i, r.criteriaMode, r.shouldUseNativeValidation));
    return B(s), a;
  }, U = async (s) => {
    const { errors: a } = await F(s);
    if (s)
      for (const l of s) {
        const g = d(a, l);
        g ? E(t.errors, l, g) : T(t.errors, l);
      }
    else
      t.errors = a;
    return a;
  }, W = async (s, a, l = {
    valid: !0
  }) => {
    for (const g in s) {
      const y = s[g];
      if (y) {
        const { _f: o, ...v } = y;
        if (o) {
          const D = c.array.has(o.name), M = y._f && zt(y._f);
          M && A.validatingFields && B([g], !0);
          const J = await $e(y, c.disabled, n, G, r.shouldUseNativeValidation && !a, D);
          if (M && A.validatingFields && B([g]), J[o.name] && (l.valid = !1, a))
            break;
          !a && (d(J, o.name) ? D ? kt(t.errors, J, o.name) : E(t.errors, o.name, J[o.name]) : T(t.errors, o.name));
        }
        !$(v) && await W(v, a, l);
      }
    }
    return l.valid;
  }, Z = () => {
    for (const s of c.unMount) {
      const a = d(i, s);
      a && (a._f.refs ? a._f.refs.every((l) => !Re(l)) : !Re(a._f.ref)) && pe(s);
    }
    c.unMount = /* @__PURE__ */ new Set();
  }, ee = (s, a) => !r.disabled && (s && a && E(n, s, a), !ie(me(), u)), k = (s, a, l) => bt(s, c, {
    ...f.mount ? n : R(a) ? u : re(s) ? { [s]: a } : a
  }, l, a), p = (s) => we(d(f.mount ? n : u, s, r.shouldUnregister ? d(u, s, []) : [])), L = (s, a, l = {}) => {
    const g = d(i, s);
    let y = a;
    if (g) {
      const o = g._f;
      o && (!o.disabled && E(n, s, St(a, o)), y = Fe(o.ref) && j(a) ? "" : a, Vt(o.ref) ? [...o.ref.options].forEach((v) => v.selected = y.includes(v.value)) : o.refs ? he(o.ref) ? o.refs.forEach((v) => {
        (!v.defaultChecked || !v.disabled) && (Array.isArray(y) ? v.checked = !!y.find((D) => D === v.value) : v.checked = y === v.value || !!y);
      }) : o.refs.forEach((v) => v.checked = v.value === y) : Ge(o.ref) ? o.ref.value = "" : (o.ref.value = y, o.ref.type || h.state.next({
        name: s,
        values: O(n)
      })));
    }
    (l.shouldDirty || l.shouldTouch) && _(s, y, l.shouldTouch, l.shouldDirty, !0), l.shouldValidate && oe(s);
  }, H = (s, a, l) => {
    for (const g in a) {
      if (!a.hasOwnProperty(g))
        return;
      const y = a[g], o = s + "." + g, v = d(i, o);
      (c.array.has(s) || I(y) || v && !v._f) && !le(y) ? H(o, y, l) : L(o, y, l);
    }
  }, K = (s, a, l = {}) => {
    const g = d(i, s), y = c.array.has(s), o = O(a);
    E(n, s, o), y ? (h.array.next({
      name: s,
      values: O(n)
    }), (A.isDirty || A.dirtyFields || w.isDirty || w.dirtyFields) && l.shouldDirty && h.state.next({
      name: s,
      dirtyFields: ge(u, n),
      isDirty: ee(s, o)
    })) : g && !g._f && !j(o) ? H(s, o, l) : L(s, o, l), He(s, c) && h.state.next({ ...t, name: s }), h.state.next({
      name: f.mount ? s : void 0,
      values: O(n)
    });
  }, te = async (s) => {
    f.mount = !0;
    const a = s.target;
    let l = a.name, g = !0;
    const y = d(i, l), o = (M) => {
      g = Number.isNaN(M) || le(M) && isNaN(M.getTime()) || ie(M, d(n, l, M));
    }, v = de(r.mode), D = de(r.reValidateMode);
    if (y) {
      let M, J;
      const ve = a.type ? ct(y._f) : ht(s), ue = s.type === Ve.BLUR || s.type === Ve.FOCUS_OUT, Ut = !Gt(y._f) && !r.resolver && !d(t.errors, l) && !y._f.deps || Qt(ue, d(t.touchedFields, l), t.isSubmitted, D, v), Me = He(l, c, ue);
      E(n, l, ve), ue ? (!a || !a.readOnly) && (y._f.onBlur && y._f.onBlur(s), S && S(0)) : y._f.onChange && y._f.onChange(s);
      const Oe = _(l, ve, ue), Lt = !$(Oe) || Me;
      if (!ue && h.state.next({
        name: l,
        type: s.type,
        values: O(n)
      }), Ut)
        return (A.isValid || w.isValid) && (r.mode === "onBlur" ? ue && C() : ue || C()), Lt && h.state.next({ name: l, ...Me ? {} : Oe });
      if (!ue && Me && h.state.next({ ...t }), r.resolver) {
        const { errors: it } = await F([l]);
        if (o(ve), g) {
          const Tt = ft(t.errors, i, l), at = ft(it, i, Tt.name || l);
          M = at.error, l = at.name, J = $(it);
        }
      } else
        B([l], !0), M = (await $e(y, c.disabled, n, G, r.shouldUseNativeValidation))[l], B([l]), o(ve), g && (M ? J = !1 : (A.isValid || w.isValid) && (J = await W(i, !0)));
      g && (y._f.deps && oe(y._f.deps), m(l, J, M, Oe));
    }
  }, ye = (s, a) => {
    if (d(t.errors, a) && s.focus)
      return s.focus(), 1;
  }, oe = async (s, a = {}) => {
    let l, g;
    const y = z(s);
    if (r.resolver) {
      const o = await U(R(s) ? s : y);
      l = $(o), g = s ? !y.some((v) => d(o, v)) : l;
    } else s ? (g = (await Promise.all(y.map(async (o) => {
      const v = d(i, o);
      return await W(v && v._f ? { [o]: v } : v);
    }))).every(Boolean), !(!g && !t.isValid) && C()) : g = l = await W(i);
    return h.state.next({
      ...!re(s) || (A.isValid || w.isValid) && l !== t.isValid ? {} : { name: s },
      ...r.resolver || !s ? { isValid: l } : {},
      errors: t.errors
    }), a.shouldFocus && !g && fe(i, ye, s ? y : c.mount), g;
  }, me = (s) => {
    const a = {
      ...f.mount ? n : u
    };
    return R(s) ? a : re(s) ? d(a, s) : s.map((l) => d(a, l));
  }, Je = (s, a) => ({
    invalid: !!d((a || t).errors, s),
    isDirty: !!d((a || t).dirtyFields, s),
    error: d((a || t).errors, s),
    isValidating: !!d(t.validatingFields, s),
    isTouched: !!d((a || t).touchedFields, s)
  }), Dt = (s) => {
    s && z(s).forEach((a) => T(t.errors, a)), h.state.next({
      errors: s ? t.errors : {}
    });
  }, Qe = (s, a, l) => {
    const g = (d(i, s, { _f: {} })._f || {}).ref, y = d(t.errors, s) || {}, { ref: o, message: v, type: D, ...M } = y;
    E(t.errors, s, {
      ...M,
      ...a,
      ref: g
    }), h.state.next({
      name: s,
      errors: t.errors,
      isValid: !1
    }), l && l.shouldFocus && g && g.focus && g.focus();
  }, pt = (s, a) => X(s) ? h.state.subscribe({
    next: (l) => "values" in l && s(k(void 0, a), l)
  }) : k(s, a, !0), Xe = (s) => h.state.subscribe({
    next: (a) => {
      Jt(s.name, a.name, s.exact) && Yt(a, s.formState || A, Rt, s.reRenderRoot) && s.callback({
        values: { ...n },
        ...t,
        ...a,
        defaultValues: u
      });
    }
  }).unsubscribe, Et = (s) => (f.mount = !0, w = {
    ...w,
    ...s.formState
  }, Xe({
    ...s,
    formState: w
  })), pe = (s, a = {}) => {
    for (const l of s ? z(s) : c.mount)
      c.mount.delete(l), c.array.delete(l), a.keepValue || (T(i, l), T(n, l)), !a.keepError && T(t.errors, l), !a.keepDirty && T(t.dirtyFields, l), !a.keepTouched && T(t.touchedFields, l), !a.keepIsValidating && T(t.validatingFields, l), !r.shouldUnregister && !a.keepDefaultValue && T(u, l);
    h.state.next({
      values: O(n)
    }), h.state.next({
      ...t,
      ...a.keepDirty ? { isDirty: ee() } : {}
    }), !a.keepIsValid && C();
  }, Ze = ({ disabled: s, name: a }) => {
    (Y(s) && f.mount || s || c.disabled.has(a)) && (s ? c.disabled.add(a) : c.disabled.delete(a));
  }, Ee = (s, a = {}) => {
    let l = d(i, s);
    const g = Y(a.disabled) || Y(r.disabled);
    return E(i, s, {
      ...l || {},
      _f: {
        ...l && l._f ? l._f : { ref: { name: s } },
        name: s,
        mount: !0,
        ...a
      }
    }), c.mount.add(s), l ? Ze({
      disabled: Y(a.disabled) ? a.disabled : r.disabled,
      name: s
    }) : N(s, !0, a.value), {
      ...g ? { disabled: a.disabled || r.disabled } : {},
      ...r.progressive ? {
        required: !!a.required,
        min: _e(a.min),
        max: _e(a.max),
        minLength: _e(a.minLength),
        maxLength: _e(a.maxLength),
        pattern: _e(a.pattern)
      } : {},
      name: s,
      onChange: te,
      onBlur: te,
      ref: (y) => {
        if (y) {
          Ee(s, a), l = d(i, s);
          const o = R(y.value) && y.querySelectorAll && y.querySelectorAll("input,select,textarea")[0] || y, v = Ht(o), D = l._f.refs || [];
          if (v ? D.find((M) => M === o) : o === l._f.ref)
            return;
          E(i, s, {
            _f: {
              ...l._f,
              ...v ? {
                refs: [
                  ...D.filter(Re),
                  o,
                  ...Array.isArray(d(u, s)) ? [{}] : []
                ],
                ref: { type: o.type, name: s }
              } : { ref: o }
            }
          }), N(s, !1, void 0, o);
        } else
          l = d(i, s, {}), l._f && (l._f.mount = !1), (r.shouldUnregister || a.shouldUnregister) && !(mt(c.array, s) && f.action) && c.unMount.add(s);
      }
    };
  }, Ce = () => r.shouldFocusError && fe(i, ye, c.mount), Ct = (s) => {
    Y(s) && (h.state.next({ disabled: s }), fe(i, (a, l) => {
      const g = d(i, l);
      g && (a.disabled = g._f.disabled || s, Array.isArray(g._f.refs) && g._f.refs.forEach((y) => {
        y.disabled = g._f.disabled || s;
      }));
    }, 0, !1));
  }, et = (s, a) => async (l) => {
    let g;
    l && (l.preventDefault && l.preventDefault(), l.persist && l.persist());
    let y = O(n);
    if (h.state.next({
      isSubmitting: !0
    }), r.resolver) {
      const { errors: o, values: v } = await F();
      t.errors = o, y = O(v);
    } else
      await W(i);
    if (c.disabled.size)
      for (const o of c.disabled)
        T(y, o);
    if (T(t.errors, "root"), $(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await s(y, l);
      } catch (o) {
        g = o;
      }
    } else
      a && await a({ ...t.errors }, l), Ce(), setTimeout(Ce);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: $(t.errors) && !g,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), g)
      throw g;
  }, Mt = (s, a = {}) => {
    d(i, s) && (R(a.defaultValue) ? K(s, O(d(u, s))) : (K(s, a.defaultValue), E(u, s, O(a.defaultValue))), a.keepTouched || T(t.touchedFields, s), a.keepDirty || (T(t.dirtyFields, s), t.isDirty = a.defaultValue ? ee(s, O(d(u, s))) : ee()), a.keepError || (T(t.errors, s), A.isValid && C()), h.state.next({ ...t }));
  }, tt = (s, a = {}) => {
    const l = s ? O(s) : u, g = O(l), y = $(s), o = y ? u : g;
    if (a.keepDefaultValues || (u = l), !a.keepValues) {
      if (a.keepDirtyValues) {
        const v = /* @__PURE__ */ new Set([
          ...c.mount,
          ...Object.keys(ge(u, n))
        ]);
        for (const D of Array.from(v))
          d(t.dirtyFields, D) ? E(o, D, d(n, D)) : K(D, d(o, D));
      } else {
        if (je && R(s))
          for (const v of c.mount) {
            const D = d(i, v);
            if (D && D._f) {
              const M = Array.isArray(D._f.refs) ? D._f.refs[0] : D._f.ref;
              if (Fe(M)) {
                const J = M.closest("form");
                if (J) {
                  J.reset();
                  break;
                }
              }
            }
          }
        if (a.keepFieldsRef)
          for (const v of c.mount)
            K(v, d(o, v));
        else
          i = {};
      }
      n = r.shouldUnregister ? a.keepDefaultValues ? O(u) : {} : O(o), h.array.next({
        values: { ...o }
      }), h.state.next({
        values: { ...o }
      });
    }
    c = {
      mount: a.keepDirtyValues ? c.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, f.mount = !A.isValid || !!a.keepIsValid || !!a.keepDirtyValues, f.watch = !!r.shouldUnregister, h.state.next({
      submitCount: a.keepSubmitCount ? t.submitCount : 0,
      isDirty: y ? !1 : a.keepDirty ? t.isDirty : !!(a.keepDefaultValues && !ie(s, u)),
      isSubmitted: a.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: y ? {} : a.keepDirtyValues ? a.keepDefaultValues && n ? ge(u, n) : t.dirtyFields : a.keepDefaultValues && s ? ge(u, s) : a.keepDirty ? t.dirtyFields : {},
      touchedFields: a.keepTouched ? t.touchedFields : {},
      errors: a.keepErrors ? t.errors : {},
      isSubmitSuccessful: a.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: u
    });
  }, rt = (s, a) => tt(X(s) ? s(n) : s, a), Ot = (s, a = {}) => {
    const l = d(i, s), g = l && l._f;
    if (g) {
      const y = g.refs ? g.refs[0] : g.ref;
      y.focus && (y.focus(), a.shouldSelect && X(y.select) && y.select());
    }
  }, Rt = (s) => {
    t = {
      ...t,
      ...s
    };
  }, st = {
    control: {
      register: Ee,
      unregister: pe,
      getFieldState: Je,
      handleSubmit: et,
      setError: Qe,
      _subscribe: Xe,
      _runSchema: F,
      _focusError: Ce,
      _getWatch: k,
      _getDirty: ee,
      _setValid: C,
      _setFieldArray: ae,
      _setDisabledField: Ze,
      _setErrors: P,
      _getFieldArray: p,
      _reset: tt,
      _resetDefaultValues: () => X(r.defaultValues) && r.defaultValues().then((s) => {
        rt(s, r.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: Z,
      _disableForm: Ct,
      _subjects: h,
      _proxyFormState: A,
      get _fields() {
        return i;
      },
      get _formValues() {
        return n;
      },
      get _state() {
        return f;
      },
      set _state(s) {
        f = s;
      },
      get _defaultValues() {
        return u;
      },
      get _names() {
        return c;
      },
      set _names(s) {
        c = s;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return r;
      },
      set _options(s) {
        r = {
          ...r,
          ...s
        };
      }
    },
    subscribe: Et,
    trigger: oe,
    register: Ee,
    handleSubmit: et,
    watch: pt,
    setValue: K,
    getValues: me,
    reset: rt,
    resetField: Mt,
    clearErrors: Dt,
    unregister: pe,
    setError: Qe,
    setFocus: Ot,
    getFieldState: Je
  };
  return {
    ...st,
    formControl: st
  };
}
var ne = () => {
  if (typeof crypto < "u" && crypto.randomUUID)
    return crypto.randomUUID();
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (r) => {
    const t = (Math.random() * 16 + e) % 16 | 0;
    return (r == "x" ? t : t & 3 | 8).toString(16);
  });
}, Ue = (e, r, t = {}) => t.shouldFocus || R(t.shouldFocus) ? t.focusName || `${e}.${R(t.focusIndex) ? r : t.focusIndex}.` : "", Le = (e, r) => [
  ...e,
  ...z(r)
], Te = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function Ie(e, r, t) {
  return [
    ...e.slice(0, r),
    ...z(t),
    ...e.slice(r)
  ];
}
var Ne = (e, r, t) => Array.isArray(e) ? (R(e[t]) && (e[t] = void 0), e.splice(t, 0, e.splice(r, 1)[0]), e) : [], Be = (e, r) => [
  ...z(r),
  ...z(e)
];
function tr(e, r) {
  let t = 0;
  const i = [...e];
  for (const u of r)
    i.splice(u - t, 1), t++;
  return we(i).length ? i : [];
}
var Pe = (e, r) => R(r) ? [] : tr(e, z(r).sort((t, i) => t - i)), We = (e, r, t) => {
  [e[r], e[t]] = [e[t], e[r]];
}, gt = (e, r, t) => (e[r] = t, e);
function ur(e) {
  const r = ke(), { control: t = r.control, name: i, keyName: u = "id", shouldUnregister: n, rules: f } = e, [c, S] = b.useState(t._getFieldArray(i)), x = b.useRef(t._getFieldArray(i).map(ne)), A = b.useRef(c), w = b.useRef(!1);
  A.current = c, t._names.array.add(i), b.useMemo(() => f && t.register(i, f), [t, f, i]), De(() => t._subjects.array.subscribe({
    next: ({ values: _, name: m }) => {
      if (m === i || !m) {
        const F = d(_, i);
        Array.isArray(F) && (S(F), x.current = F.map(ne));
      }
    }
  }).unsubscribe, [t, i]);
  const h = b.useCallback((_) => {
    w.current = !0, t._setFieldArray(i, _);
  }, [t, i]), G = (_, m) => {
    const F = z(O(_)), U = Le(t._getFieldArray(i), F);
    t._names.focus = Ue(i, U.length - 1, m), x.current = Le(x.current, F.map(ne)), h(U), S(U), t._setFieldArray(i, U, Le, {
      argA: Te(_)
    });
  }, q = (_, m) => {
    const F = z(O(_)), U = Be(t._getFieldArray(i), F);
    t._names.focus = Ue(i, 0, m), x.current = Be(x.current, F.map(ne)), h(U), S(U), t._setFieldArray(i, U, Be, {
      argA: Te(_)
    });
  }, C = (_) => {
    const m = Pe(t._getFieldArray(i), _);
    x.current = Pe(x.current, _), h(m), S(m), !Array.isArray(d(t._fields, i)) && E(t._fields, i, void 0), t._setFieldArray(i, m, Pe, {
      argA: _
    });
  }, B = (_, m, F) => {
    const U = z(O(m)), W = Ie(t._getFieldArray(i), _, U);
    t._names.focus = Ue(i, _, F), x.current = Ie(x.current, _, U.map(ne)), h(W), S(W), t._setFieldArray(i, W, Ie, {
      argA: _,
      argB: Te(m)
    });
  }, ae = (_, m) => {
    const F = t._getFieldArray(i);
    We(F, _, m), We(x.current, _, m), h(F), S(F), t._setFieldArray(i, F, We, {
      argA: _,
      argB: m
    }, !1);
  }, V = (_, m) => {
    const F = t._getFieldArray(i);
    Ne(F, _, m), Ne(x.current, _, m), h(F), S(F), t._setFieldArray(i, F, Ne, {
      argA: _,
      argB: m
    }, !1);
  }, P = (_, m) => {
    const F = O(m), U = gt(t._getFieldArray(i), _, F);
    x.current = [...U].map((W, Z) => !W || Z === _ ? ne() : x.current[Z]), h(U), S([...U]), t._setFieldArray(i, U, gt, {
      argA: _,
      argB: F
    }, !0, !1);
  }, N = (_) => {
    const m = z(O(_));
    x.current = m.map(ne), h([...m]), S([...m]), t._setFieldArray(i, [...m], (F) => F, {}, !0, !1);
  };
  return b.useEffect(() => {
    if (t._state.action = !1, He(i, t._names) && t._subjects.state.next({
      ...t._formState
    }), w.current && (!de(t._options.mode).isOnSubmit || t._formState.isSubmitted) && !de(t._options.reValidateMode).isOnSubmit)
      if (t._options.resolver)
        t._runSchema([i]).then((_) => {
          const m = d(_.errors, i), F = d(t._formState.errors, i);
          (F ? !m && F.type || m && (F.type !== m.type || F.message !== m.message) : m && m.type) && (m ? E(t._formState.errors, i, m) : T(t._formState.errors, i), t._subjects.state.next({
            errors: t._formState.errors
          }));
        });
      else {
        const _ = d(t._fields, i);
        _ && _._f && !(de(t._options.reValidateMode).isOnSubmit && de(t._options.mode).isOnSubmit) && $e(_, t._names.disabled, t._formValues, t._options.criteriaMode === Q.all, t._options.shouldUseNativeValidation, !0).then((m) => !$(m) && t._subjects.state.next({
          errors: kt(t._formState.errors, m, i)
        }));
      }
    t._subjects.state.next({
      name: i,
      values: O(t._formValues)
    }), t._names.focus && fe(t._fields, (_, m) => {
      if (t._names.focus && m.startsWith(t._names.focus) && _.focus)
        return _.focus(), 1;
    }), t._names.focus = "", t._setValid(), w.current = !1;
  }, [c, i, t]), b.useEffect(() => (!d(t._formValues, i) && t._setFieldArray(i), () => {
    const _ = (m, F) => {
      const U = d(t._fields, m);
      U && U._f && (U._f.mount = F);
    };
    t._options.shouldUnregister || n ? t.unregister(i) : _(i, !1);
  }), [i, t, u, n]), {
    swap: b.useCallback(ae, [h, i, t]),
    move: b.useCallback(V, [h, i, t]),
    prepend: b.useCallback(q, [h, i, t]),
    append: b.useCallback(G, [h, i, t]),
    remove: b.useCallback(C, [h, i, t]),
    insert: b.useCallback(B, [h, i, t]),
    update: b.useCallback(P, [h, i, t]),
    replace: b.useCallback(N, [h, i, t]),
    fields: b.useMemo(() => c.map((_, m) => ({
      ..._,
      [u]: x.current[m] || ne()
    })), [c, u])
  };
}
function nr(e = {}) {
  const r = b.useRef(void 0), t = b.useRef(void 0), [i, u] = b.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: X(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    isReady: !1,
    defaultValues: X(e.defaultValues) ? void 0 : e.defaultValues
  });
  if (!r.current)
    if (e.formControl)
      r.current = {
        ...e.formControl,
        formState: i
      }, e.defaultValues && !X(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: f, ...c } = er(e);
      r.current = {
        ...c,
        formState: i
      };
    }
  const n = r.current.control;
  return n._options = e, De(() => {
    const f = n._subscribe({
      formState: n._proxyFormState,
      callback: () => u({ ...n._formState }),
      reRenderRoot: !0
    });
    return u((c) => ({
      ...c,
      isReady: !0
    })), n._formState.isReady = !0, f;
  }, [n]), b.useEffect(() => n._disableForm(e.disabled), [n, e.disabled]), b.useEffect(() => {
    e.mode && (n._options.mode = e.mode), e.reValidateMode && (n._options.reValidateMode = e.reValidateMode);
  }, [n, e.mode, e.reValidateMode]), b.useEffect(() => {
    e.errors && (n._setErrors(e.errors), n._focusError());
  }, [n, e.errors]), b.useEffect(() => {
    e.shouldUnregister && n._subjects.state.next({
      values: n._getWatch()
    });
  }, [n, e.shouldUnregister]), b.useEffect(() => {
    if (n._proxyFormState.isDirty) {
      const f = n._getDirty();
      f !== i.isDirty && n._subjects.state.next({
        isDirty: f
      });
    }
  }, [n, i.isDirty]), b.useEffect(() => {
    e.values && !ie(e.values, t.current) ? (n._reset(e.values, {
      keepFieldsRef: !0,
      ...n._options.resetOptions
    }), t.current = e.values, u((f) => ({ ...f }))) : n._resetDefaultValues();
  }, [n, e.values]), b.useEffect(() => {
    n._state.mount || (n._setValid(), n._state.mount = !0), n._state.watch && (n._state.watch = !1, n._subjects.state.next({ ...n._formState })), n._removeUnmounted();
  }), r.current.formState = vt(i, n), r.current;
}
export {
  ar as C,
  ir as F,
  nr as a,
  ur as b,
  ke as u
};
//# sourceMappingURL=index.esm-DpgNxKa2.js.map
